import { cDisplay, createParam } from "../creator/cDisplay";
import { bookDisplay } from "./bookDisplay";
//import { gameDanglerDisplay } from "./_decrapted/gameDanglerDisplay";
import { interfaceDisplay } from "./interfaceDisplay";
import { mapDisplay } from "./mapDisplay";
import { parallaxDisplay } from "./parallaxDisplay";
import { gameQuizDisplay } from "./gameQuizDisplay";
import { gameCanidoDisplay } from "./gameCanidoDisplay";
import { resultDisplay } from "./resultDisplay";
import { gameJustitiaDisplay } from "./gameJustitiaDisplay";
import { gameOpinionDisplay } from "./gameOpinion";
import { gameMobilePreviewDisplay } from "./gameMobilePreviewDisplay";
import { backpackDisplay } from "./backpackDisplay";
import { backpack2Display } from "./backpack2Display";
import { sceneBusDisplay } from "./sceneBusDisplay";
import { gameTicketmachine } from "./gameTicketmachine";
import { gamePoliceDisplay } from "./gamePoliceDisplay";
import { gamePackmanDisplay } from "./gamePackmanDisplay";
import { gameMagicDisplay } from "./gameMagicDisplay";
import { votingDisplay } from "./votingDisplay";
import { gameFairDisplay } from "./gameFairDisplay";
import { diplomaDisplay } from "./diplomaDisplay";
import { gameHershipDisplay } from "./gameHershipDisplay";
import { gameFindFive } from "./gameFindFive";
import { gameListFristSecond } from "./gameListFristSecond";
import { gamePartyBox } from "./gamePartyBox";
import { gameSlogan } from "./gameSlogan";
import { gamePower } from "./gamePower";
import { gameWahlomat } from "./gameWahlomat";
import { result2Display } from "./result2Display";
import { gameRepresentative } from "./gameRepresentative";
import { gameShedLock } from "./gameShedLock";
import { gameShed } from "./gameShed";
import { gameClassroom } from "./gameClassroom";
import { clockDisplay } from "./clockDisplay";
import { gameElectionCheck } from "./gameElectionCheck";
import { tvDisplay } from "./tvDisplay";
import { citySquereDisplay } from "./citySquereDisplay";
import { game5pct } from "./game5pct";


export class displayTypes {

  public static register(){

    cDisplay.registerDisplayType('interface',(opt:createParam)=>{
      return new interfaceDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('book',(opt:createParam)=>{
      return new bookDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('backpack',(opt:createParam)=>{
      return new backpackDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('backpack2',(opt:createParam)=>{
      return new backpack2Display(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('quiz',(opt:createParam)=>{
      return new  gameQuizDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('map',(opt:createParam)=>{
      return new mapDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('parallax',(opt:createParam)=>{
      return new parallaxDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameListFristSecond',(opt:createParam)=>{
      return new gameListFristSecond(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameFindFive',(opt:createParam)=>{
      return new gameFindFive(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameTicketmchine',(opt:createParam)=>{
      return new gameTicketmachine(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameCanIDo',(opt:createParam)=>{
      return new gameCanidoDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('result',(opt:createParam)=>{
      return new resultDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameJustitia',(opt:createParam)=>{
      return new  gameJustitiaDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameOpinion',(opt:createParam)=>{
      return new  gameOpinionDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('mobilePreview',(opt:createParam)=>{
      return new  gameMobilePreviewDisplay(opt.scene,opt.data,opt.onReady)
    });


    cDisplay.registerDisplayType('displaySceneBus',(opt:createParam)=>{
      return new  sceneBusDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gamePoliceDisplay',(opt:createParam)=>{
      return new  gamePoliceDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameMagicDisplay',(opt:createParam)=>{
      return new  gameMagicDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gamePackmanDisplay',(opt:createParam)=>{
      return new  gamePackmanDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('votingDisplay',(opt:createParam)=>{
      return new votingDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('diplomaDisplay',(opt:createParam)=>{
      return new  diplomaDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameFairDisplay',(opt:createParam)=>{      
      return new gameFairDisplay(opt.scene,opt.data,opt.onReady)
    });


    cDisplay.registerDisplayType('gameHership',(opt:createParam)=>{      
      return new  gameHershipDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gamePartyBox',(opt:createParam)=>{      
      return new  gamePartyBox(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameSlogan',(opt:createParam)=>{      
      return new  gameSlogan(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gamePower',(opt:createParam)=>{      
      return new  gamePower(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameWahlomat',(opt:createParam)=>{      
      return new  gameWahlomat(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('result2',(opt:createParam)=>{      
      return new  result2Display(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameRepresentative',(opt:createParam)=>{      
      return new  gameRepresentative(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameShedLock',(opt:createParam)=>{      
      return new  gameShedLock(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameShed',(opt:createParam)=>{      
      return new  gameShed(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameClassroom',(opt:createParam)=>{      
      return new  gameClassroom(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('clockDisplay',(opt:createParam)=>{      
      return new  clockDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('gameElectionCheck',(opt:createParam)=>{      
      return new  gameElectionCheck(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('tvDisplay',(opt:createParam)=>{      
      return new  tvDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('citySquereDisplay',(opt:createParam)=>{      
      return new  citySquereDisplay(opt.scene,opt.data,opt.onReady)
    });

    cDisplay.registerDisplayType('game5pct',(opt:createParam)=>{      
      return new  game5pct(opt.scene,opt.data,opt.onReady)
    });

  }

}